import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cv-reset-confirm-dialog',
  templateUrl: './reset-confirm-dialog.component.html',
  styleUrls: ['./reset-confirm-dialog.component.scss']
})
export class ResetConfirmDialogComponent {

  @Input() title: string;
  @Input() prompt: string;
  @Input() isCXone: boolean;

  constructor(
      public modal: NgbActiveModal,
  ) { }

}
